import React, { useEffect } from 'react';
import { HydraAdmin, ResourceGuesser } from '@api-platform/admin';

import authProvider from './authProvider';
import { apiDocumentationParser, dataProvider, entrypoint } from './dataProvider';
import LoginPage from './views/auth/LoginPage';
import { Routes as CustomRoutes } from './views/CustomRouter';
import { CoiTheme } from './layout/CoiTheme';
import { CoiLayout } from './layout/CoiLayout';
import i18nProvider from './i18nProvider';
import websites from './views/websites';
import mobileConsentSolutions from './views/mobile-consent-solutions';
import universalConsentItems from './views/universal_consent_items';
import domains from './views/domains';
import consentBanners from './views/consent-banners';
import trackingCategories from './views/tracking-categories';
import trackingDefinitions from './views/tracking-definitions';
import teamMates from './views/teammates';
import accounts from './views/accounts';
import Dashboard from './views/Dashboard';
import { Resource } from 'react-admin';
import { getDecodedToken } from './token';
import { Intercom } from './utils';
import blankRAViews from './components/BlankRAViews';

export default () => {

  useEffect(() => {
    const token = getDecodedToken() || {};
    Intercom.boot(token.email);
  });

  return (
    <HydraAdmin
      disableTelemetry
      customRoutes={CustomRoutes}
      loginPage={LoginPage}
      apiDocumentationParser={apiDocumentationParser}
      authProvider={authProvider}
      entrypoint={entrypoint}
      dataProvider={dataProvider}
      dashboard={Dashboard}
      theme={CoiTheme}
      layout={CoiLayout}
      i18nProvider={i18nProvider}
    >
      <ResourceGuesser name="accounts" {...accounts} />
      <ResourceGuesser name="websites" {...websites} />
      <ResourceGuesser name="universal_consent_items" {...universalConsentItems} />
      <ResourceGuesser name="universal_consent_solutions" {...mobileConsentSolutions} />
      <ResourceGuesser name="universal_consent_item_translations" {...blankRAViews} />
      <ResourceGuesser name="domains" {...domains} />
      <ResourceGuesser name="languages" {...blankRAViews} />
      <ResourceGuesser name="cookie_consent_texts"/>
      <Resource name="mobile_operating_systems" {...blankRAViews} />
      <ResourceGuesser name="pop_up_templates" {...consentBanners} />
      <ResourceGuesser name="declaration_templates"/>
      <ResourceGuesser name="choice_box_templates"/>
      <ResourceGuesser name="cookie_category_translations" {...blankRAViews} />
      <ResourceGuesser name="data_processors" {...blankRAViews} />
      <ResourceGuesser name="data_processor_descriptions" {...blankRAViews} />
      <ResourceGuesser name="tracking_results" {...blankRAViews} />
      <ResourceGuesser name="tracking_categories" {...trackingCategories} />
      <ResourceGuesser name="tracking_definitions" {...trackingDefinitions} />
      <ResourceGuesser name="custom_scan_cookies" {...blankRAViews} />
      <ResourceGuesser name="compliance_dashboard_access_levels" {...blankRAViews} />
      <ResourceGuesser name="universal_consent_item_types" {...blankRAViews} />
      <ResourceGuesser name="teammates" {...teamMates} />
    </HydraAdmin>
  );
};
